import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import ContractAI from "@/pages/ContractAI";
import ProjectAI from "@/pages/ProjectAI";
import FinanceAI from "@/pages/FinanceAI";
import Automation from "@/pages/Automation";
import Training from "@/pages/Training";
import SharedView from "@/pages/SharedView";
import PaymentReturn from "@/pages/PaymentReturn";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import { CreditsProvider } from "@/lib/CreditsContext";
import { ActiveProjectProvider } from "@/lib/ActiveProjectContext";
import { AuthProvider } from "@/lib/AuthContext";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <CreditsProvider>
        <ActiveProjectProvider>
        <Routes>
          <Route path="share/:token" element={<SharedView />} />
          <Route path="payment/success" element={<PaymentReturn />} />
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="contract" element={<ContractAI />} />
            <Route path="project" element={<ProjectAI />} />
            <Route path="finance" element={<FinanceAI />} />
            <Route path="automation" element={<Automation />} />
            <Route path="training" element={<Training />} />
            <Route path="account" element={<Account />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
        </ActiveProjectProvider>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0F172A",
              border: "1px solid #1E293B",
              color: "#F8FAFC",
              borderRadius: "2px",
            },
          }}
        />
      </CreditsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
